import { FlexRow } from '@/components/common/Flex';
import { Text } from '@/components/common/Typography';
import { MenuItem, Spinner } from '@chakra-ui/react';
import ActionMenu from '../common/ActionMenu';
import { MenuButton } from '../common/Button';
import { ChevronDown } from '../common/icons';

export interface FinancialEntityTypeSelectMenuButtonProps<
    TValue extends string,
> {
    options: { value: TValue; label: string }[];
    value: TValue;
    onChange: (value: TValue) => void;
    isLoading?: boolean;
}

const FinancialEntityTypeSelectMenuButton = <TValue extends string>({
    options,
    value,
    onChange,
    isLoading,
}: FinancialEntityTypeSelectMenuButtonProps<TValue>) => {
    const selectedValueLabel = options.find((o) => o.value === value)?.label;
    return (
        <ActionMenu
            menuButton={
                <MenuButton
                    color="textMuted"
                    onClickEvent="Financial Entity Type Select Menu Button Clicked"
                >
                    <FlexRow alignItems="center" gap={1}>
                        {isLoading ? (
                            <Spinner h={2} w={2} />
                        ) : (
                            <>
                                <Text fontSize="sm">{selectedValueLabel}</Text>
                                <ChevronDown />
                            </>
                        )}
                    </FlexRow>
                </MenuButton>
            }
        >
            {options.map((option) => {
                return (
                    <MenuItem
                        key={option.value}
                        onClick={() => {
                            if (option.value !== value) {
                                onChange(option.value);
                            }
                        }}
                    >
                        {option.label}
                    </MenuItem>
                );
            })}
        </ActionMenu>
    );
};

export default FinancialEntityTypeSelectMenuButton;
